export type BannerType = keyof ReturnType<typeof banners>

export const banners = () =>
  ({
    NoAccountFound: {
      variant: 'error',
      text: 'No account found',
    },
    InternalServerError: {
      variant: 'error',
      text: 'Internal Server Error',
    },
    AccountConfirmationResentSuccessfully: {
      variant: 'constructive',
      text: 'Confirmation email was resent successfully',
    },
    ForgottenPasswordResentSuccessfully: {
      variant: 'constructive',
      text: 'A new email for resetting your password was resent',
    },
    EmailPasswordMisMatch: {
      variant: 'error',
      text: 'Email address and password combination not recognised - check them and try again',
    },
    ExpiredLink: {
      variant: 'error',
      text: 'This link has expired - enter your details and we will send a new link',
    },
    AccountActivationSucceeded: {
      variant: 'constructive',
      text: 'Your account has been activated',
    },
    ResettingPasswordFailed: {
      variant: 'error',
      text: 'There was an error, please try again',
    },
    ResettingPasswordSucceeded: {
      variant: 'constructive',
      text: 'Password updated. You can now log in.',
    },
    AccountIsNotVerified: {
      variant: 'error',
      text: 'To activate your account, we need to verify your email address - check your inbox or %link:start%request a new activation email%link:end%',
    },
    NewVerificationEmailSent: {
      variant: 'constructive',
      text: 'A new verification email has been sent to your email address',
    },
    SendingNewEmailVerificationFailed: {
      variant: 'error',
      text: 'Failed to resend verification email. Please try again.',
    },
    UserAlreadyExist: {
      variant: 'error',
      text: 'An account with this email already exists - try to %link:start%log in%link:end%',
    },
    AccountHasAlreadyBeenActivated: {
      variant: 'error',
      text: 'This account has already been activated',
    },
    EmailFormattingError: {
      variant: 'error',
      text: 'Invalid email address format. Please enter a valid email address (e.g., name@example.com).',
    },
    UnknownErrorHappened: {
      variant: 'error',
      text: 'Something has gone wrong. Try again or come back later.',
    },
  }) as const
